// extracted by mini-css-extract-plugin
module.exports = {"dialogScheduleItemServiceTime":"DialogScheduleItemServiceTime_dialogScheduleItemServiceTime_24r75"};